<script setup lang="ts">
defineProps<{ errorText?: string }>();
</script>

<template>
  <div v-if="errorText" class="label-error" :title="errorText">{{ errorText }}</div>
</template>

<style lang="stylus" scoped>
.label-error
  font-family var(--typography-font)
  font-weight 400
  line-height 16px
  font-size 12px
  color var(--text-negative)
  white-space nowrap
  overflow hidden
  text-overflow ellipsis
</style>
